import { render, staticRenderFns } from "./viewArtVer.vue?vue&type=template&id=add2f558&scoped=true&"
import script from "./viewArtVer.vue?vue&type=script&lang=js&"
export * from "./viewArtVer.vue?vue&type=script&lang=js&"
import style0 from "./viewArtVer.vue?vue&type=style&index=0&id=add2f558&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add2f558",
  null
  
)

export default component.exports